export default class SchoolEnrollment {

  static readonly HS_GED = new SchoolEnrollment('HS_GED', 'schoolEnrollment.hsGed');
  static readonly ALT_HS = new SchoolEnrollment('ALT_HS', 'schoolEnrollment.altHs');
  static readonly POSTSECONDARY = new SchoolEnrollment('POSTSECONDARY', 'schoolEnrollment.postsecondary');
  static readonly NOT_ENROLLED = new SchoolEnrollment('NOT_ENROLLED', 'schoolEnrollment.notEnrolled');

  static all() {
    return [
      SchoolEnrollment.HS_GED,
      SchoolEnrollment.ALT_HS,
      SchoolEnrollment.POSTSECONDARY,
      SchoolEnrollment.NOT_ENROLLED,
    ]
  }

  // private to disallow creating other instances of this type
  private constructor(public readonly key: string, public readonly label: any) {
  }

  toString() {
    return this.key;
  }
}
